import { useGetConstrainedContent } from '@/hooks/useGetConstrainedContent';
import type { ExitIntentCF, SectionConstraintsCF } from '@/types';
import { isTypeExitIntent, isTypeSectionConstraints } from '@/types/contentful';
import ExitIntent from './ExitIntent';

interface Props {
  exitIntent: ExitIntentCF | SectionConstraintsCF;
}

export default function ConstrainedExitIntent({ exitIntent }: Props) {
  const getConstrainedContent = useGetConstrainedContent();

  let constrainedExitIntent: ExitIntentCF | undefined;
  if (isTypeExitIntent(exitIntent)) {
    constrainedExitIntent = exitIntent;
  } else if (isTypeSectionConstraints(exitIntent)) {
    constrainedExitIntent = getConstrainedContent<ExitIntentCF>({
      constrainedSection: exitIntent,
      include: ['exitIntent'],
    })?.[0];
  }

  if (!constrainedExitIntent) return null;

  return <ExitIntent config={constrainedExitIntent} />;
}
